var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{staticClass:"text-12"},[_vm._v(_vm._s(_vm.first))]),_c('el-breadcrumb-item',{staticClass:"text-12"},[_vm._v(_vm._s(_vm.second))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }